import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatSnackBar } from '@angular/material';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NoiseAbatement } from '../models/noise-abatement.model';
import { LandingSurface } from '../models/landing-surface.model';
import { NoiseAbatementService } from '../service/noise-abatement.service';


@Component({
  selector: 'app-edit-noise-abatement',
  templateUrl: './edit-noise-abatement.component.html',
  styleUrls: ['./edit-noise-abatement.component.scss']
})
export class EditNoiseAbatementComponent implements OnInit {
  noise: NoiseAbatement;
  originalNoise: NoiseAbatement;
  isNew = false;
  isLoading = false;
  airportID: number;
  itemsToChange: Set<number>;
  formGroup: FormGroup;
  landingSurfaces: Array<LandingSurface>;
  selectedRunway: string;
  selectedAppliesTo: string;
  selectedApproachDeparture: string;
  selectedText: string;

  constructor(private _matDialogRef: MatDialogRef<EditNoiseAbatementComponent>,
              public _snackBar: MatSnackBar,
              @Inject(MAT_DIALOG_DATA) data,
              private _noiseAbatementService: NoiseAbatementService) {
    this.noise = data.noise || new NoiseAbatement();
    this.isNew = data.isNew || false;
    this.airportID = data.airID;
    this.originalNoise = Object.assign(new NoiseAbatement(), data.noise);
    this.itemsToChange = new Set<number> ();
    this.selectedRunway = this.noise.runway ? this.noise.runway : 'All';
    this.selectedAppliesTo = NoiseAbatement.formatAppliesTo(this.noise.appliesTo);
    this.selectedApproachDeparture = NoiseAbatement.formatAppDep(this.noise.appDep);
    this.selectedText = this.noise.text ? this.noise.text : '';
    this.landingSurfaces = data.landingSurfaces || [];
  }

  ngOnInit() {
    this._matDialogRef.backdropClick().subscribe(() => {
      this.close({cancelBtnClicked: true});
    });
    this.formGroup = new FormGroup({
      runway: new FormControl(this.selectedRunway, [Validators.required]),
      appliesTo: new FormControl(this.selectedAppliesTo, [Validators.required]),
      appDep: new FormControl(this.selectedApproachDeparture, [Validators.required]),
      text: new FormControl(this.selectedText, [Validators.required, Validators.maxLength(1000)])
    });
  }

  get runways(): Array<string> {
    const tempRunways: string[] = [];
    for (const surface of this.landingSurfaces) {
      for (const takeOffLandArea of surface.takeOffLandAreas) {
        tempRunways.push(takeOffLandArea.name);
      }
    }
    return tempRunways;
  }

  /**
   * triggered by save button click event
   * @return {Promise<void>}
   */
  async save() {
    try {
      let res: any;
      this.noise.runway = this.formGroup.get('runway').value;
      this.noise.appliesTo = NoiseAbatement.parseAppliesTo(this.formGroup.get('appliesTo').value);
      this.noise.appDep = NoiseAbatement.parseAppDep(this.formGroup.get('appDep').value);
      this.noise.text = this.formGroup.get('text').value;
      if (this.isNew) {
        res = await this._noiseAbatementService.postNoiseAbatement(this.airportID, this.noise);
        this.noise = NoiseAbatement.parse(res);
      } else {
        res = await this._noiseAbatementService.putNoiseAbatement(this.airportID, this.noise);
        Object.assign(this.noise, NoiseAbatement.parse(res));
        this.noise = NoiseAbatement.parse(res);
      }
      this.close({cancelBtnClicked: false, success: true, noise: this.noise});
    } catch (e) {
      this.close({cancelBtnClicked: false, success: false});
    }
  }

  /**
   * triggered by cancel button click event
   */
  cancel () {
    this.close({cancelBtnClicked: true});
  }

  /**
   * closes modal
   * @param data
   */
  close(data: any) {
    if (data && data.cancelBtnClicked) {
      Object.assign(this.noise, this.originalNoise);
    }
    data['isNew'] = this.isNew;
    this._matDialogRef.close(data);
  }
}
